import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { HeartHandshake } from "lucide-react";

export function NudgeBanner({ compact = false }) {
  const [nudge, setNudge] = useState(null);

  useEffect(() => {
    api.get("/share/partner/nudge").then(({ data }) => setNudge(data.nudge)).catch(() => {});
  }, []);

  if (!nudge) return null;
  const when = new Date(nudge.created_at).toLocaleDateString("en-US", { weekday: "long" });

  return (
    <div
      className={`rounded-2xl border border-[#D8CBB9] bg-[#F4EDE2]/70 flex items-start gap-3 ${compact ? "mt-5 p-4" : "mt-8 p-5"}`}
      data-testid="nudge-banner"
    >
      <HeartHandshake size={18} className="text-[#5F7463] mt-0.5 shrink-0" />
      <div>
        <p className="text-xs uppercase tracking-[0.18em] text-[#5F7463] font-semibold">Someone looked at your week</p>
        <p className="mt-1 font-serif-display text-lg text-[#2C221E] leading-snug" data-testid="nudge-banner-text">
          “{nudge.text}”
          <span className="ml-2 text-sm font-sans text-[#8C7A70]">— {when}</span>
        </p>
      </div>
    </div>
  );
}
